import React, { useState } from "react";

export default function PatientSummary() {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  const handleAddComment = () => {
    if (newComment.trim()) {
      setComments([...comments, newComment]);
      setNewComment("");
    }
  };

  return (
    <div className=" p-6">
      <div className="max-w-6xl mx-auto bg-white  rounded-lg p-6">
        <h1 className="text-2xl font-bold mb-6">Patient Summary</h1>

        {/* Document Status Section */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Document Status</h2>
          <div className="grid grid-cols-3 gap-6">
            <div className="border border-gray-300 p-4 rounded-lg">
              <p className="text-sm font-medium">ID Proof</p>
              <p className="text-green-600 font-semibold">Approved</p>
            </div>
            <div className="border border-gray-300 p-4 rounded-lg">
              <p className="text-sm font-medium">Insurance Document</p>
              <p className="text-red-600 font-semibold">Rejected</p>
            </div>
            <div className="border border-gray-300 p-4 rounded-lg">
              <p className="text-sm font-medium">Medical History</p>
              <p className="text-yellow-600 font-semibold">Pending</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
